import './WordArrangementInput.less';
import React from 'react';
import {ReactSortable} from "react-sortablejs";
import DraftView from '../../../components/draft-view/DraftView';
import {jsonToObject} from '../../../../bootstrap/utils/json';

export default function WordArrangementInput({content, options, value, onChange, readOnly}) {
    const contentState = jsonToObject(content);

    if (value.length === 0) {
        value = options.slice();
    }

    const items = value.map(item => {
        return <li key={item.id}>
            {item.text || item.value}
        </li>;
    });

    return <div className={'word-arrangement-input' + (readOnly ? ' readonly' : '')}>
        {
            contentState !== null &&
            <div className="content">
                <DraftView contentState={contentState}/>
            </div>
        }
        {
            readOnly
                ?
                <ul>
                    {items}
                </ul>
                :
                <ReactSortable tag="ul" list={value} setList={onChange} animation={200}>
                    {items}
                </ReactSortable>
        }
    </div>;
}
